import type {
    ComponentChildren,
    JSX,
} from "preact";
import {
    forwardRef,
} from "preact/compat";

type SpinnerSize = "sm" | "md" | "lg";

type LoadingSpinnerProps = JSX.HTMLAttributes<SVGSVGElement> & {
    size?: SpinnerSize;
};

const sizeStyles: Record<SpinnerSize, string> = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
};

export const LoadingSpinner = forwardRef<SVGSVGElement, LoadingSpinnerProps>(
    ({
        size = "md",
        className = "",
        ...props
    }, ref) => {
        return (
            <svg
                ref={ref}
                className={`animate-spin text-accent ${
                    sizeStyles[size]
                } ${className}`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                {...props}
            >
                <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                />
                <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
            </svg>
        );
    },
);

type SkeletonProps = {
    className?: string;
};

export const Skeleton = ({
    className = "",
}: SkeletonProps): ComponentChildren => {
    return (
        <div
            className={`animate-pulse bg-bg-tertiary rounded ${className}`}
        />
    );
};
